export enum EAutomationsType {
  AutoMessage = 'AutoMessage',
  AutoReview = 'AutoReview',
  AutoTask = 'AutoTask',
  AutoPrice = 'AutoPrice',
  AutoPublish = 'AutoPublish',
}
